var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
var pageSectionStyle = {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    minHeight: 200,
    backgroundColor: 'transparent',
};
var PageSection = function (_a) {
    var style = _a.style, sectionId = _a.sectionId, children = _a.children;
    return (_jsx(Box, { id: sectionId, style: __assign(__assign({}, pageSectionStyle), style), children: children }));
};
export default PageSection;
